module.exports = {"id":"176901","name":"Hugo Droguett","rating":"72","photo":"./data/images/photos/4/176901.png","club":{"name":"Uni. Concepción","logo":"./data/images/clubs/Uni.Concepcion.png"},"positions":["MOC","MG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HugoDroguett0.json
// module id = 1752
// module chunks = 0